module.exports = __webpack_public_path__ + "images/alert-bell-blue-026f7309.svg";